import { Injectable } from '@angular/core';
import { IMultisiteItem, MultisiteService } from '@df/core/service/multisite';

@Injectable({
    providedIn: 'root'
})
export class MultisiteServiceDecorator extends MultisiteService {
    protected override getAll(): IMultisiteItem[] {
        return super.getAll().filter(store => store.siteId !== 'collections-pwa' && store.siteId !== 'us');
    }
}
